export default {
    props: {
        value: {
            default: false,
        },
        icon: {
            type: String,
            default: '',
            required: false,
        },
        falseIcon: {
            type: String,
            default: '',
            required: false,
        },
        trueIcon: {
            type: String,
            default: '',
            required: false,
        },
    },
    functional: true,
    render(createElement, { props }) {
        return [
            createElement('span', {
                class: {
                    [props.icon]: props.icon,
                    [props.falseIcon]: props.falseIcon,
                },
                directives: [
                    {
                        name: 'show',
                        value: !props.value,
                    },
                ],
            }),
            createElement('span', {
                class: {
                    [props.trueIcon]: props.trueIcon,
                },
                directives: [
                    {
                        name: 'show',
                        value: props.value,
                    },
                ],
            }),
        ];
    },
};
